import React from 'react';

interface CheckListProps {
  width?: number;
  height?: number;
  className?: string;
  color?: string;
}

const CheckList: React.FC<CheckListProps> = ({ 
  width = 24, 
  height = 24, 
  className = '', 
  color = 'currentColor' 
}) => {
  return (
    <svg 
      width={width} 
      height={height} 
      viewBox="0 0 48 48" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path 
        d="M8 14C10.2091 14 12 12.2091 12 10C12 7.79086 10.2091 6 8 6C5.79086 6 4 7.79086 4 10C4 12.2091 5.79086 14 8 14Z" 
        fill="none" 
        stroke={color} 
        strokeWidth="4" 
        strokeLinejoin="round"
      />
      <path 
        d="M8 26C9.10457 26 10 25.1046 10 24C10 22.8954 9.10457 22 8 22C6.89543 22 6 22.8954 6 24C6 25.1046 6.89543 26 8 26Z" 
        stroke={color} 
        strokeWidth="4" 
        strokeLinejoin="round"
      />
      <path 
        d="M8 40C9.10457 40 10 39.1046 10 38C10 36.8954 9.10457 36 8 36C6.89543 36 6 36.8954 6 38C6 39.1046 6.89543 40 8 40Z" 
        stroke={color} 
        strokeWidth="4" 
        strokeLinejoin="round"
      />
      <path 
        d="M20 24H44" 
        stroke={color} 
        strokeWidth="4" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
      <path 
        d="M20 38H44" 
        stroke={color} 
        strokeWidth="4" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
      <path 
        d="M20 10H44" 
        stroke={color} 
        strokeWidth="4" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default CheckList;

